import React from 'react';
import styled from 'styled-components';
import { BestPrice } from '@catalogo/ui-americanas-mobile-buybox/src/components/best-price';
import { PaymentConditionText } from '@catalogo/ui-americanas-mobile-buybox/src/components/payment-condition-text';
import { PriceText } from '@catalogo/ui-americanas-mobile-buybox/src/styles';

const InstallmentText = styled.p`
  color: ${({ theme }) => theme.grey.dark};
  font-weight: 400;
  margin-top: 2px;
  font-size: 12px;
  line-height: 14px;
  ${({ $hasPaymentConditionText }) => $hasPaymentConditionText && 'margin-top: 8px;'}
`;

export const Price = ({
  mainPayment,
  defaultPriceText,
  international,
  buyTogetherPriceText,
  paymentInstallmentText,
  hasPaymentConditionText,
}) => {
  if (buyTogetherPriceText) {
    return (
      <>
        <PriceText $isFloating={true}>{buyTogetherPriceText}</PriceText>
        <div>com item sugerido</div>
      </>
    );
  }

  return (
    <>
      <BestPrice
        defaultPriceText={defaultPriceText}
        payment={mainPayment}
        international={international}
        isFloating={true}
      />
      <PaymentConditionText payment={mainPayment} isFloating={true} />
      {paymentInstallmentText && (
        <InstallmentText $hasPaymentConditionText={hasPaymentConditionText}>{paymentInstallmentText}</InstallmentText>
      )}
    </>
  );
};
